// extracted by mini-css-extract-plugin
export default {"self":"BackToHomeButton-module--self--b5eck"};